<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="regulador.exames"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="!item.id"
                    @click="edit(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="disableDestroy(item)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { formats } from '@/mixins'

export default {
    data() {

        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    formatter: codigo => codigo ? this.formatProcedimento(codigo) : '-',
                    sortable: true,
                    class: 'col-min',
                },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'grupoNome', label: 'Grupo', sortable: true },
                {
                    key: 'exigeDocumentoAnexo',
                    label: 'Exige documento anexo',
                    sortable: true,
                    class: 'text-center',
                    formatter: exigeDocumentoAnexo => exigeDocumentoAnexo ? 'SIM' : 'NÃO',
                },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        disableDestroy(exame) {

            return this.data.model.solicitantes.some(s => !!s.reguladores
                .find(r => r.infraestruturaId === this.regulador.infraestruturaId
                    && !!r.exames.find(e => e.id === exame.id)))
        },
        destroy(exame) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o exame?',
                async () => this.regulador.exames.splice(this.regulador.exames.indexOf(exame), 1)
            )
        },
        edit(exame) {
        
            this.$emit('exameEdit', exame)
        }
    },
    mixins: [formats],
    props: {
        data: { type: Object, required: true },
        regulador: { type: Object, required: true },
    }
}
</script>